var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading-bg"},[_c('div',{staticClass:"loading-content"},[_c('div',{staticClass:"spinner"}),(!!_vm.text)?_c('p',[_vm._v(_vm._s(_vm.text))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }